import React from 'react';
import { Motion, spring, presets } from 'react-motion';
import styles from './Styles';
import { connect } from 'react-redux';
import ActionTypes from '../actions/types';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';

var rowHeight = 30;

class ArrowSlider extends React.Component {
  getArrowStyle = (width) => {
    const { height, arrowPos, yStartingPosition, side, strikeArrow, noc } =
      this.props;
    const greaterfifteen = width > 1500;
    const islessFifteenk = width >= 1400 && width <= 1500;
    const islessFourteenk = width >= 1300 && width <= 1400;
    const islessthirteenk = width >= 1200 && width <= 1300;
    const islesstwelvek = width >= 1100 && width <= 1200;
    const islesselevenk = width >= 850 && width <= 1100;
    const isIphone14 = width >= 400 && width <= 600;
    if (this.props.rowHeight !== 20) {
      rowHeight = 30;
    }
    var y =
      height * rowHeight * arrowPos +
      yStartingPosition * rowHeight +
      rowHeight +
      rowHeight / 5;
    if (this.props.rowHeight === 20) {
      rowHeight = 20;
      y = yStartingPosition * rowHeight;
    }
    if (!strikeArrow)
      return {
        display: height === 0 ? 'none' : '',
        position: 'absolute',
        borderTop: '12px solid transparent',
        borderRight: side === 'right' ? '20px solid rgb(17, 118, 184)' : 'none',
        borderLeft: side === 'right' ? 'none' : '20px solid rgb(17, 118, 184)',
        borderBottom: '12px solid transparent',
        WebkitTransform: `translate3d(${side === 'right' ? '35px' : '0px'
          }, ${y}px, 0)`,
        transform: `translate3d(${side === 'right' ? '35px' : '0px'
          }, ${y}px, 0)`,
      };

    // Strike arrows

    return {
      position: 'absolute',
      borderTop: '10px solid transparent',
      borderRight: side === 'right' ? '10px solid rgb(255, 255, 255)' : 'none',
      borderLeft: side === 'right' ? 'none' : '10px solid rgb(255, 255, 255)',
      borderBottom: '10px solid transparent',
      WebkitTransform: `translate3d(${side === 'right' ? '35px' : '0px'
        }, ${y}px, 0)`,
      transform: `translate3d(${side === 'right'
        ? '35px'
        : noc === 'noc'
          ? greaterfifteen
            ? '-40%'
            : islessFifteenk
              ? '-3px'
              : islessFourteenk
                ? '-3px'
                : islessthirteenk
                  ? '-3px'
                  : islesstwelvek
                    ? '-3px'
                    : islesselevenk
                      ? '-3px'
                      : isIphone14
                        ? '-10px'
                        : '-3px'

          : '0px'
        }, ${y}px, 0)`,
      zIndex: 3,
    };
  };

  getWarningStyle = () => {
    const { height, arrowPos, yStartingPosition, side } = this.props;
    const y =
      height * rowHeight * arrowPos +
      yStartingPosition * rowHeight +
      rowHeight +
      rowHeight / 5;

    return {
      display: height === 0 ? 'none' : '',
      position: 'absolute',
      width: 20,
      WebkitTransform: `translate3d(${side === 'right' ? '57px' : '-24px'}, ${y + 3
        }px, 0)`,
      transform: `translate3d(${side === 'right' ? '57px' : '-24px'}, ${y + 3
        }px, 0)`,
    };
  };

  render() {
    const {
      height,
      arrowPos,
      yStartingPosition,
      side,
      hide,
      strikeArrow,
      advancedStrike,
      isMobile,
      width,
    } = this.props;
    const { warnings } = this.props.optionChainState;

    if (hide) return <div style={styles.hiddenArrow} />;

    const arrowStyle = this.getArrowStyle(width, isMobile);
    const warningStyle = this.getWarningStyle();

    let containerStyle;
    if (side === 'right' && !strikeArrow)
      containerStyle = styles.rightArrowContainer;
    if (side === 'left' && !strikeArrow)
      containerStyle = styles.leftArrowContainer;
    if (side === 'left' && !strikeArrow && isMobile)
      containerStyle = styles.leftArrowMobileContainer;
    if (side === 'right' && !strikeArrow && isMobile)
      containerStyle = styles.rightArrowMobileContainer;
    if (side === 'right' && strikeArrow && !advancedStrike)
      containerStyle = styles.rightStrikeArrowContainer;
    if (side === 'left' && strikeArrow && !advancedStrike)
      containerStyle = styles.leftStrikeArrowContainer;
    if (side === 'left' && strikeArrow && !advancedStrike && isMobile)
      containerStyle = styles.leftStrikeArrowMobileContainer;
    if (side === 'right' && strikeArrow && advancedStrike)
      containerStyle = styles.rightAdvancedStrikeArrowContainer;
    if (side === 'right' && strikeArrow && advancedStrike && isMobile)
      containerStyle = styles.rightAdvancedStrikeArrowMobileContainer;
    if (side === 'left' && strikeArrow && advancedStrike)
      containerStyle = styles.leftAdvancedStrikeArrowContainer;

    return (
      <div>
        <Motion
          style={{
            y: spring(
              height * rowHeight * arrowPos +
              yStartingPosition * rowHeight +
              rowHeight +
              12 / 2,
              presets.stiff
            ),
          }}
        >
          {({ y }) => (
            <div style={containerStyle}>
              <div style={arrowStyle} />
              <div style={{ boxShadow: '1px 1px gray' }}></div>

              {warnings.length > 0 && !this.props.basicPutSingleWarning && (
                <img src="../warningIcon.png" style={warningStyle} alt="" />
              )}
            </div>
          )}
        </Motion>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  appState: state.appReducer,
  optionChainState: state.optionChainReducer,
});

const mapDispatchToProps = (dispatch) => ({
  setAppStateAction: (newState) =>
    dispatch({
      type: ActionTypes.SET_APP_STATE,
      payload: newState,
    }),
  setOptionChainStateAction: (newState) =>
    dispatch({
      type: ActionTypes.SET_OPTION_CHAIN_STATE,
      payload: newState,
    }),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ArrowSlider)
);



// WEBPACK FOOTER //
// ./src/components/ArrowSlider.js